import { useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import Research from "../components/Research";
import GetItSection from "../components/GetItSection";
import EditorialMarquee from "../components/Marquee";

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView();
      }, 400);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <main data-testid="home-page">
      <Hero />
      <TrustBar />
      <Research />
      <EditorialMarquee />
      <GetItSection />
      <section
        className="border-t border-blue-100 bg-fv-ice/60 py-8"
        data-testid="precaution-strip"
      >
        <div className="mx-auto flex max-w-5xl items-start gap-4 px-5 lg:px-8">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-fv-navy">
            <AlertTriangle className="h-4 w-4 text-fv-cyan" />
          </div>
          <p className="text-sm leading-relaxed text-fv-navy/70">
            <span className="font-bold text-fv-navy">Precaution:</span> If you
            have an impaired liver or kidney, it is not advisable to take
            FellesViar. Consume after a meal, as Boswellia can be sensitive for
            those with gastric discomfort.
          </p>
        </div>
      </section>
    </main>
  );
}
